"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJWT = void 0;
const util_1 = require("../../util");
const getJWT = async (address, payload, useAsRefreshToken = false, chain = "ALL") => {
    try {
        const data = !useAsRefreshToken ? await (0, util_1.API_NODE_HANDLER)(`/api/message/get-jwt`, "POST", "", { address, signature: payload, chain }) : await (0, util_1.API_NODE_HANDLER)(`/api/message/get-jwt`, "PUT", "", { address, refreshToken: payload });
        return { JWT: data.token, refreshToken: data.refreshToken, error: null };
    }
    catch (err) {
        return { JWT: null, error: "Invalid Signature" };
    }
};
exports.getJWT = getJWT;
